// Status das notas fiscais gravados pelo servidor (status da Spedy em maiúsculas + status internos)
const VERDE = { bg: "#dcfce7", cor: "#15803d" };
const AMARELO = { bg: "#fef3c7", cor: "#b45309" };
const VERMELHO = { bg: "#fee2e2", cor: "#b91c1c" };
const CINZA = { bg: "#f3f4f6", cor: "#374151" };

const STATUS_NOTA = {
    PENDENTE: { label: "PROCESSANDO", ...AMARELO },
    AUTHORIZED: { label: "EMITIDA", ...VERDE },
    REJECTED: { label: "REJEITADA", ...VERMELHO },
    DENIED: { label: "NEGADA", ...VERMELHO },
    ERRO: { label: "ERRO NO ENVIO", ...VERMELHO },
    "CANCELAMENTO EM ANDAMENTO": { label: "CANCELANDO", ...AMARELO },
    CANCELED: { label: "CANCELADA", ...CINZA },
};

export const statusNota = (status) => STATUS_NOTA[status] || { label: status || "-", ...CINZA };

// PDF existe a partir da autorização (inclusive notas canceladas)
export const podeBaixarPdf = (status) => ["AUTHORIZED", "CANCELAMENTO EM ANDAMENTO", "CANCELED"].includes(status);

export const podeCancelar = (status) => status === "AUTHORIZED";

// Notas que entram no faturamento
export const notaFaturada = (status) => status === "AUTHORIZED";

// dadosNFSe pode chegar como objeto ou como string JSON
export const dadosNota = (nota) => {
    let dados = nota?.dadosNFSe;
    while (typeof dados === "string") {
        try {
            dados = JSON.parse(dados);
        } catch {
            return {};
        }
    }
    if (!dados || typeof dados !== "object") return {};
    return dados.event && dados.data ? dados.data : dados;
};

export const tomadorNota = (nota) => dadosNota(nota).receiver?.name || "";

export const numeroNota = (nota) => nota?.numeroNota || dadosNota(nota).number || "";

// Motivo informado pela prefeitura/Spedy quando a nota é rejeitada ou negada
export const mensagemNota = (nota) => nota?.mensagemErro || dadosNota(nota).processingDetail?.message || "";
